import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Row, Col, Form, Button, Card, Alert } from 'react-bootstrap';
import { Formik, Field } from 'formik';
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';
// TARDY temporarily disabled
// import { toast } from 'react-toastify';
import Layout from './DashboardLayout';
import { sToHMSColonSeparated, getUserData } from '../helpers';
import {
  PAGINATION_LIMIT,
  LOCAL_STORAGE_TEAM_OWNER,
  // TARDY temporarily disabled
  // NO_DATA,
  // LOCAL_STORAGE_USER_DATA,
} from '../constants';
import { teamService, reportService, clientsService } from '../services';
import Loading from '../components/Loader';
import {
  StatusDropdown,
  TimeZoneDropdown,
  MemberMultiSelectDropdown,
  MultiSelectItemDropdown,
} from '../components/common';
import AdherenceDataTable from '../components/reports/AdherenceDataTable';
// TARDY temporarily disabled
// import Tardy from '../components/reports/Tardy';
import ReportGenerationModal from '../components/ReportGenerationModal';

class MemberLiveActivity extends Component {
  state = {
    isLoading: false,
    isUpdatingProjectsList: false,
    isUpdatingTeamsList: false,
    isUpdatingClientsList: false,
    teamMembersList: [],
    teamGroupList: [],
    startDate: moment().startOf('day'),
    endDate: moment().endOf('day'),
    activityMetadata: {},
    numberOfDaysSelected: 1,
    daysLimit: 31,
    page: 1,
    limit: PAGINATION_LIMIT,
    selectedTeamMember: 'all',
    status: [],
    project: [],
    site: [],
    clientId: [],
    siteDropdownState: [],
    projectsList: [],
    activityData: [],
    totalRows: 0,
    initLoad: true,
    timeZone: getUserData('timeZone') || '',
    clientsData: [],
    changeSource: null,
    reportModalDisplay: false,
    formParams: {},
    showViewingLimitAlert: false,
  };

  liveActivityFormRef = React.createRef();

  memberSelectInputRef = React.createRef();

  projectSelectInputRef = React.createRef();

  clientSelectInputRef = React.createRef();

  siteSelectInputRef = React.createRef();

  pageHeading = {
    preTitle: 'Reports',
    title: 'Adherence Report',
  };

  componentDidMount() {
    const { timeZone } = this.state;
    this.getClientData();
    this.getMembersAndProjects();
    this.handleGenerateData({
      timeZone,
      teamOwnerId: localStorage.getItem('teamOwnerId'),
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { changeSource } = this.state;

    // Only act if changeSource has changed
    if (!changeSource || changeSource === prevState.changeSource) return;

    const formik = this.liveActivityFormRef.current;
    const memberSelect = this.memberSelectInputRef?.current?.select;
    const clientSelect = this.clientSelectInputRef?.current?.select;
    const projectSelect = this.projectSelectInputRef?.current?.select;

    const clearSelect = (selectRef) => selectRef?.clearValue();
    const resetFields = (fields) =>
      fields.forEach((f) => formik.setFieldValue(f, []));

    switch (changeSource) {
      case 'site':
        resetFields(['clientId', 'project', 'selectedTeamMember']);
        [memberSelect, clientSelect, projectSelect].forEach(clearSelect);
        this.getClientData();
        setTimeout(() => {
          this.getMembersAndProjects();
        }, 200);
        break;

      case 'client':
        resetFields(['selectedTeamMember', 'project']);
        [memberSelect, projectSelect].forEach(clearSelect);
        this.getMembersAndProjects();
        break;

      case 'project':
        resetFields(['selectedTeamMember']);
        clearSelect(memberSelect);
        this.getMembersWithProject();
        break;

      default:
        break;
    }

    // Reset changeSource after handling to prevent re-trigger
    this.setState({ changeSource: null });
  }

  /* TARDY temporarily disabled
  handleTardyRequest = (param) => {
    this.setState({ isLoading: true });
    const { activityData } = this.state;
    const params = {
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      ...param,
    };
    reportService
      .send_tardy_request(params)
      .then((response) => {
        if (
          response &&
          response.data &&
          response.data[0] &&
          response.data[0].logs &&
          response.data[0].logs[0]
        ) {
          toast.success(NO_DATA.TARDY_REQUEST);
          const userdata = JSON.parse(
            localStorage.getItem(LOCAL_STORAGE_USER_DATA)
          );
          response.data[0].logs[0].updatedUserName =
            userdata.firstName + (userdata.lastName || '');
          const getIndex = activityData.findIndex(
            (item) => item._id === param.scheduleId
          );

          activityData[getIndex].activityData.tardyStatus =
            response.data[0].status;
          activityData[getIndex].activityData.tardyLogs = response.data[0].logs;
          activityData[getIndex].activityData.tardyId = response.data[0]._id;

          this.setState({
            activityData,
          });
        }
      })
      .catch((error) => {})
      .finally(() => {
        this.setState({ isLoading: false });
      });
  };

  handleTardyApproval = (param) => {
    this.setState({ isLoading: true });
    const { activityData } = this.state;
    const params = {
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      tardyId: param.data?.activityData?.tardyId,
      status: param.status.toLowerCase(),
      note: param.data?.activityData?.tardyLogs[0]?.note || '',
    };

    reportService
      .update_tardy_request(params)
      .then((response) => {
        if (response && response.status) {
          if (response.data.status === 'approved') {
            toast.success(NO_DATA.TARDY_APPROVE);
          }
          if (response.data.status === 'rejected') {
            toast.success(NO_DATA.TARDY_REJECT);
          }

          const getIndex = activityData.findIndex(
            (item) => item._id === param.data?._id
          );
          const userdata = JSON.parse(
            localStorage.getItem(LOCAL_STORAGE_USER_DATA)
          );
          response.data.logs[0].updatedUserName =
            param.data?.activityData?.tardyLogs[0]?.updatedUserName;

          response.data.logs[1].updatedUserName =
            userdata.firstName + (userdata.lastName || '');

          activityData[getIndex].activityData.tardyStatus =
            response.data.status;

          activityData[getIndex].activityData.tardyLogs = response.data.logs;

          activityData[getIndex].activityData.tardyId = response.data._id;

          this.setState({
            activityData,
          });
        }
      })
      .catch((error) => {})
      .finally(() => {
        this.setState({ isLoading: false });
      });
  };
  */

  calculateCheckinAdherence = (
    shiftStartTime,
    checkinTime,
    totalShiftMinutes
  ) => {
    const shiftStart = moment(shiftStartTime);
    const checkin = moment(checkinTime);

    // Calculate the difference in minutes
    const lateMinutes = checkin.diff(shiftStart, 'minutes');

    const adherence = checkin.isAfter(shiftStart)
      ? (1 - lateMinutes / totalShiftMinutes) * 100
      : 100;

    return adherence <= 0
      ? `${0}%`
      : `${Math.round(adherence) >= 100 ? 100 : Math.round(adherence)}%`; // Ensuring adherence doesn't go below 0%
  };

  calculateCheckoutAdherence = (
    shiftEndTime,
    checkoutTime,
    totalShiftMinutes
  ) => {
    const shiftEnd = moment(shiftEndTime);
    const checkout = moment(checkoutTime);
    // Calculate the difference in minutes

    const adherence = checkout.isBefore(shiftEnd)
      ? (1 - shiftEnd.diff(checkout, 'minutes') / totalShiftMinutes) * 100
      : 100;

    return adherence <= 0
      ? `${0}%`
      : `${Math.round(adherence) >= 100 ? 100 : Math.round(adherence)}%`; // Ensuring adherence doesn't go below 0%
  };

  // Function to calculate the difference in minutes between two time strings
  calculateDifferenceInMinutes = (startTime, endTime) => {
    const start = moment(startTime); // shift time
    const end = moment(endTime);
    // Calculate and return the difference in minutes
    return end.diff(start, 'minutes');
  };

  // Function to calculate shift adherence
  calculateShiftAdherence = (
    shiftStartTime,
    shiftEndTime,
    checkinTime,
    checkoutTime
  ) => {
    const shiftStartTimes = moment(shiftStartTime);
    const shiftEndTimes = moment(shiftEndTime);
    const checkinTimes = moment(checkinTime);
    const checkoutTimes = moment(checkoutTime);
    const setTimes = {
      setStartTimes: checkinTimes,
      setEndTimes: shiftEndTimes,
    };

    // less then shiftStartTimes
    if (checkinTimes.isBefore(shiftStartTimes)) {
      setTimes.setStartTimes = shiftStartTimes;
    }

    if (checkoutTimes.isBefore(shiftEndTimes)) {
      setTimes.setEndTimes = checkoutTimes;
    }

    // Convert shift times and working times into minutes
    let adherenceMinutes = 0;
    if (
      this.calculateDifferenceInMinutes(
        setTimes.setStartTimes,
        setTimes.setEndTimes
      ) > 0
    ) {
      adherenceMinutes = this.calculateDifferenceInMinutes(
        setTimes.setStartTimes,
        setTimes.setEndTimes
      );
    }
    const shiftMinutes = this.calculateDifferenceInMinutes(
      shiftStartTime,
      shiftEndTime
    );

    // Calculate the adherence percentage (working time / shift time)
    const adherence = (adherenceMinutes / shiftMinutes) * 100;
    // Cap adherence at 100% if it exceeds 100%

    return adherence <= 0
      ? `${0}%`
      : `${Math.round(adherence) >= 100 ? 100 : Math.round(adherence)}%`; // Ensuring adherence doesn't go below 0%
  };

  handleSubmitFilter = (params) => {
    const { limit } = this.state;
    const { project, site, teamMember, status, timeZone, team } =
      this.liveActivityFormRef.current.values;
    this.setState({
      initLoad: false,
      project,
      site,
      selectedTeamMember: teamMember,
      status,
      activityData: [],
      timeZone,
      team,
    });
    params.limit = limit;
    this.handleGenerateData(params);
  };

  // Over the 7 day on-screen limit the form is never submitted, so mirror the
  // selected filters into state the same way handleSubmitFilter does.
  handleViewingLimitFilter = (values) => {
    const { project, site, clientId, teamMember, status, timeZone, team } =
      values;
    this.setState({
      showViewingLimitAlert: true,
      activityData: [],
      activityMetadata: {},
      project,
      site,
      clientId,
      selectedTeamMember: teamMember,
      status,
      timeZone,
      team,
    });
  };

  getClientData = () => {
    const { site } =
      this.liveActivityFormRef &&
      this.liveActivityFormRef.current &&
      this.liveActivityFormRef.current.values;

    this.setState((state) => ({
      ...state,
      isUpdatingClientsList: true,
    }));
    const clientParams = {
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      status: 'active',
      siteId: site,
    };
    if (site.length === 0 || site.includes('all')) {
      delete clientParams.siteId;
    }
    clientsService
      .get_client_list(clientParams)
      .then((clientData) => {
        if (clientData.data) {
          this.setState((state) => ({
            ...state,
            isUpdatingClientsList: false,
            clientsData: [...clientData.data],
          }));
        }
      })
      .catch(() => {
        this.setState((state) => ({
          ...state,
          isUpdatingClientsList: false,
        }));
      });
  };

  getMembersAndProjects = () => {
    const { site, clientId } = this.liveActivityFormRef.current.values;
    const params = {
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      siteId: site,
      clientId,
    };
    if (site.length === 0 || site.includes('all')) {
      delete params.siteId;
    }
    if (clientId.length === 0 || clientId.includes('all')) {
      delete params.clientId;
    }
    this.setState({ isUpdatingProjectsList: true, isUpdatingTeamsList: true });
    teamService
      .get_team_members_and_projects(params)
      .then((result) => {
        const { teamMembers, projects, teams } = result.data;
        this.setState((state) => ({
          ...state,
          projectsList: [...projects],
          teamMembersList: [...teamMembers],
          teamGroupList: [...(teams || [])],
          isUpdatingProjectsList: false,
          isUpdatingTeamsList: false,
        }));
      })
      .catch(() => {
        this.setState((state) => ({
          ...state,
          isUpdatingProjectsList: false,
          isUpdatingTeamsList: false,
        }));
      });
  };

  handleGenerateData = (formdata, asyncOnly = false) => {
    if (!asyncOnly) {
      this.setState((state) => ({
        ...state,
        isLoading: true,
      }));
    }

    const { permissions } = this.props;
    const { excludeArchivedProjects } = this.liveActivityFormRef.current.values;

    if (
      permissions &&
      permissions.includes('team_member_view') &&
      permissions.includes('others_report_view')
    ) {
      formdata.teamMember = (formdata && formdata.teamMember) || [];
    }

    const { startDate, endDate, page } = this.state;
    const dataFromDate = moment(startDate).format('YYYY-MM-DD');
    const dataToDate = moment(endDate).format('YYYY-MM-DD');
    const params = {
      teamOwnerId: localStorage.getItem(LOCAL_STORAGE_TEAM_OWNER),
      teamMemberId: (formdata && formdata.teamMember) || 'all',
      siteId: (formdata && formdata.site) || [],
      clientId: (formdata && formdata.clientId) || [],
      projectId: (formdata && formdata.project) || [],
      fromDate: dataFromDate.concat(' 00:00:00'),
      toDate: dataToDate.concat(' 23:59:59'),
      page: (formdata && formdata.page) || page,
      status: (formdata && formdata.status) || 'all',
      timeZone: formdata && formdata.timeZone,
      excludeArchivedProjects:
        formdata.excludeArchivedProjects || excludeArchivedProjects,
      teamGroupId: [formdata.team].flat(),
    };
    if (formdata.team === 'all' || !formdata.team) {
      delete params.teamGroupId;
    }
    if (permissions && !permissions.includes('timezone_dropdown_view')) {
      delete params.timeZone;
    }
    params.limit = (formdata && formdata.limit) || PAGINATION_LIMIT;
    if (
      (formdata.teamMember && formdata.teamMember.length === 0) ||
      (formdata.teamMember && formdata.teamMember.includes('all'))
    ) {
      delete params.teamMemberId;
    }

    if (
      (params.siteId && params.siteId.length === 0) ||
      (params.siteId && params.siteId.includes('all'))
    ) {
      delete params.siteId;
    }

    if (
      (params.clientId && params.clientId.length === 0) ||
      (params.clientId && params.clientId.includes('all'))
    ) {
      delete params.clientId;
    }

    if (
      (params.projectId && params.projectId.length === 0) ||
      (params.projectId && params.projectId.includes('all'))
    ) {
      delete params.projectId;
    }
    if (params.status === 'Early checkout') {
      params.status = 'earlyCheckout';
    }
    if (params.status === 'Late checkin') {
      params.status = 'lateCheckin';
    }
    if (params.status === 'all' || !params.status) {
      delete params.status;
    }

    if (asyncOnly) {
      // The async export always generates the full report, so pagination
      // params don't apply.
      delete params.page;
      delete params.limit;
      this.setState({ formParams: { ...params } });
      return;
    }

    reportService
      .get_adherence(params)
      .then((response) => {
        this.setState({ initLoad: true });
        if (response.data) {
          const activitys = response.data.data;
          const { metadata } = response.data;
          this.setState((state) => ({
            ...state,
            activityData: activitys,
            activityMetadata: metadata,
            isLoading: false,
          }));
        }
      })
      .catch((error) => {
        this.setState((state) => ({
          ...state,
          isLoading: false,
          initLoad: true,
        }));
      });
  };

  handleDateSelect = (event, picker) => {
    const { startDate, endDate } = picker;
    picker.element.val(
      `${moment(startDate).format('MMM D, YYYY')} - ${moment(endDate).format(
        'MMM D, YYYY'
      )}`
    );
    const daysSelected = endDate.diff(startDate, 'days') + 1;
    this.setState((state) => ({
      ...state,
      startDate: moment(startDate),
      endDate: moment(endDate),
      numberOfDaysSelected: daysSelected,
    }));
  };

  handleLoader = (status) => {
    this.setState({ isLoading: status });
  };

  handleReportModalDisplay = (modalDisplay) => {
    this.setState({ reportModalDisplay: modalDisplay });
  };

  handleProjectChange = (selelctedProjectList) => {
    this.setState({
      changeSource: 'project',
      project: selelctedProjectList,
    });
  };

  handleSiteChange = (selectedSites) => {
    this.setState({
      site: selectedSites,
      isUpdatingProjectsList: true,
      changeSource: 'site',
    });
  };

  handleClientChange = (selelctedClient) => {
    this.setState({
      clientId: selelctedClient,
      changeSource: 'client',
    });
  };

  handleTeamGroupChange = (e, formikprops) => {
    formikprops.handleChange(e);
    const selectedValue = e.target.value;
    if (selectedValue !== 'all') {
      // Clear Projects
      formikprops.setFieldValue('project', []);
      if (this.projectSelectInputRef?.current?.select) {
        this.projectSelectInputRef.current.select.clearValue();
      }
      // Clear Team Member(s)
      formikprops.setFieldValue('teamMember', []);
      if (this.memberSelectInputRef?.current?.select) {
        this.memberSelectInputRef.current.select.clearValue();
      }
    }
  };

  getMembersWithProject = () => {
    const { site, clientId, project } = this.state;

    const params = {
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      summaryList: true,
      siteId: site,
      clientId,
    };
    if (project.length > 0) {
      params.projectId = project;
    }
    if (project.length === 0 || project.includes('all')) {
      delete params.projectId;
    }
    if (site.length === 0 || site.includes('all')) {
      delete params.siteId;
    }
    if (clientId.length === 0 || clientId.includes('all')) {
      delete params.clientId;
    }

    this.setState((state) => ({
      ...state,
      isLoading: true,
    }));
    teamService
      .get_team_members_with_project(params)
      .then((response) => {
        const { members } = response && response.data && response.data[0];
        this.setState((state) => ({
          ...state,
          teamMembersList: [...members],
        }));
      })
      .finally(() => {
        this.setState((state) => ({
          ...state,
          isLoading: false,
        }));
      });
  };

  handlePageChange = (page) => {
    const { clientId, selectedTeamMember, limit } = this.state;
    const { project, site, status, timeZone, team } =
      this.liveActivityFormRef.current.values;
    this.setState({
      page,
    });
    this.handleGenerateData({
      page,
      project,
      site,
      clientId,
      teamMember: selectedTeamMember,
      limit,
      timeZone,
      status,
      team,
    });
  };

  handleLimitChange = (newLimitPerPage) => {
    const { clientId, selectedTeamMember } = this.state;

    const { project, site, status, timeZone, team } =
      this.liveActivityFormRef.current.values;

    this.setState({
      limit: newLimitPerPage,
      page: 1,
    });

    this.handleGenerateData({
      limit: newLimitPerPage,
      page: 1,
      project,
      site,
      clientId,
      teamMember: selectedTeamMember,
      initLoad: false,
      timeZone,
      status,
      team,
    });
  };

  handleAsyncExport = () => {
    // Read every filter from the live form values. Component state (clientId,
    // selectedTeamMember) is only synced on form submit, which never happens
    // when the selected range is over 7 days.
    const { project, site, clientId, teamMember, status, timeZone, team } =
      this.liveActivityFormRef.current.values;
    this.handleGenerateData(
      {
        project,
        site,
        clientId,
        teamMember,
        status,
        timeZone,
        team,
      },
      true
    );
    this.handleReportModalDisplay(true);
  };

  render() {
    const {
      teamMembersList,
      startDate,
      endDate,
      activityData,
      activityMetadata,
      isLoading,
      numberOfDaysSelected,
      daysLimit,
      projectsList,
      isUpdatingProjectsList,
      isUpdatingTeamsList,
      isUpdatingClientsList,
      limit,
      initLoad,
      timeZone,
      clientsData,
      teamGroupList,
      reportModalDisplay,
      formParams,
      showViewingLimitAlert,
    } = this.state;
    const { hierarchy, permissions } = this.props;
    // Team owner ID
    const teamOwnerId = localStorage.getItem('teamOwnerId');
    const data = [];
    activityData.forEach((activity, index) => {
      data.push({
        id: `tm${index}`,
        teamMemberName: `${activity.user.firstName} ${
          activity.user.lastName || ''
        }`,
        email: activity.user.email || '',
        employeeId: activity.user.employeeId || '',
        siteName: `${activity.activityData.siteName || ''}`,
        projectName: `${
          activity.activityData.projectTitle.toString().replaceAll(',', ', ') ||
          ''
        }`,
        date: `${moment
          .utc(activity.activityData.shiftStart)
          .format('MMM DD, YYYY')}`,
        shiftStartTime: (
          <div>
            {`${
              activity.activityData.shiftStart
                ? moment
                    .utc(activity.activityData.shiftStart)
                    .format('hh:mm:ss A')
                : ''
            }`}
          </div>
        ),
        checkinTime: (
          <div>
            {activity.activityData.checkInDate &&
            activity.activityData.checkInDate !== null
              ? moment
                  .utc(activity.activityData.checkInDate)
                  .format('hh:mm:ss A')
              : ''}
          </div>
        ),
        checkinAdherence: (
          <div>
            {activity.activityData.shiftStart &&
            activity.activityData.checkInDate
              ? `${this.calculateCheckinAdherence(
                  activity.activityData.shiftStart,
                  activity.activityData.checkInDate,
                  activity.activityData.shiftDurationMinutes
                )}`
              : ''}
          </div>
        ),
        shiftEndTime: (
          <div>
            {`${
              activity.activityData.shiftEnd
                ? moment
                    .utc(activity.activityData.shiftEnd)
                    .format('hh:mm:ss A')
                : ''
            }`}
          </div>
        ),
        checkoutTime: (
          <div>
            {activity.activityData.checkOutDate &&
            activity.activityData.checkOutDate !== null
              ? moment
                  .utc(activity.activityData.checkOutDate)
                  .format('hh:mm:ss A')
              : ''}
          </div>
        ),
        checkoutAdherence: (
          <div>
            {activity.activityData.shiftEnd &&
            activity.activityData.checkOutDate
              ? this.calculateCheckoutAdherence(
                  activity.activityData.shiftEnd,
                  activity.activityData.checkOutDate,
                  activity.activityData.shiftDurationMinutes
                )
              : ''}
          </div>
        ),
        shiftTime: (
          <div>
            {activity.activityData.shiftDurationMinutes
              ? sToHMSColonSeparated(
                  activity.activityData.shiftDurationMinutes * 60
                )
              : ''}
          </div>
        ),
        totalWorkingTime: (
          <div>
            {activity.activityData.workSessionMinutes
              ? sToHMSColonSeparated(
                  Math.round(activity.activityData.workSessionMinutes * 60)
                )
              : ''}
          </div>
        ),
        shiftAdherence: (
          <div>
            {activity.activityData.shiftStart &&
            activity.activityData.shiftEnd &&
            activity.activityData.checkInDate &&
            activity.activityData.checkOutDate
              ? this.calculateShiftAdherence(
                  activity.activityData.shiftStart,
                  activity.activityData.shiftEnd,
                  activity.activityData.checkInDate,
                  activity.activityData.checkOutDate
                )
              : ''}
          </div>
        ),
        /* TARDY temporarily disabled
        ...(permissions &&
          (permissions.includes('tardy_request') ||
            permissions.includes('tardy_approval')) &&
          activity.activityData.tardyDisplay && {
            tardy: (
              <Tardy
                data={activity}
                sendRequest={this.handleTardyRequest}
                tardyApproval={this.handleTardyApproval}
              />
            ),
          }),
        */
      });
    });

    return (
      <Layout pageHeading={this.pageHeading}>
        <Formik
          initialValues={{
            teamOwnerId,
            site: [],
            clientId: [],
            team: 'all',
            project: [],
            teamMember: [],
            status: 'all',
            fromDate: startDate,
            toDate: endDate,
            page: 1,
            limit: limit || PAGINATION_LIMIT,
            timeZone,
            excludeArchivedProjects: true,
          }}
          onSubmit={(values) => {
            this.handleSubmitFilter(values);
            this.setState({ showViewingLimitAlert: false });
          }}
          innerRef={this.liveActivityFormRef}
        >
          {(formikprops) => (
            <Form onSubmit={formikprops.handleSubmit} className="mb-5">
              <Row>
                {hierarchy?.sites?.length > 0 && (
                  <Col md={6} lg={3}>
                    <MultiSelectItemDropdown
                      id="siteSelectInputRef"
                      name="site"
                      labelText="Sites"
                      fromArray={hierarchy.sites.map((site) => ({
                        value: site._id,
                        label: site.siteName,
                      }))}
                      formProps={formikprops}
                      isDisabled={hierarchy.sites.length < 1 && true}
                      innerRef={this.siteSelectInputRef}
                      isAllItemOption
                      isAllItemValuesWithNoArray
                      showErrorMessage
                      onChangeAction={this.handleSiteChange}
                    />
                  </Col>
                )}
                {permissions &&
                  permissions.includes('client_manage') &&
                  clientsData?.length > 0 && (
                    <Col md={6} lg={3}>
                      <MultiSelectItemDropdown
                        id="clientSelectInputRef"
                        name="clientId"
                        labelText="Clients"
                        fromArray={clientsData.map((client) => ({
                          value: client._id,
                          label: client.name,
                        }))}
                        formProps={formikprops}
                        isDisabled={clientsData.length < 1 && true}
                        innerRef={this.clientSelectInputRef}
                        isAllItemOption
                        isAllItemValuesWithNoArray
                        showErrorMessage
                        onChangeAction={this.handleClientChange}
                      />
                    </Col>
                  )}
                {permissions && permissions.includes('team_member_view') && (
                  <Col md={6} lg={3}>
                    <Form.Group controlId="team">
                      <Form.Label>Team Group</Form.Label>
                      <Field
                        className="form-select"
                        as="select"
                        name="team"
                        onChange={(e) => {
                          this.handleTeamGroupChange(e, formikprops);
                        }}
                      >
                        <option value="all">All</option>
                        {teamGroupList &&
                          teamGroupList.length > 0 &&
                          teamGroupList.map((teamGroup, index) => (
                            <option
                              key={`teamGroup${index}`}
                              value={teamGroup._id}
                            >
                              {teamGroup.name}
                            </option>
                          ))}
                      </Field>
                    </Form.Group>
                  </Col>
                )}
                <Col md={6} lg={3}>
                  <MultiSelectItemDropdown
                    id="projectSelectInputRef"
                    name="project"
                    labelText="Projects"
                    fromArray={projectsList.map((project) => ({
                      value: project._id,
                      label: project.title,
                    }))}
                    formProps={formikprops}
                    isDisabled={
                      formikprops.values.team !== 'all' ||
                      (projectsList.length < 1 && true)
                    }
                    innerRef={this.projectSelectInputRef}
                    isAllItemOption
                    isAllItemValuesWithNoArray
                    showErrorMessage
                    onChangeAction={this.handleProjectChange}
                  />
                </Col>
                {permissions &&
                  permissions?.includes('team_member_view') &&
                  permissions?.includes('others_report_view') && (
                    <Col md={6} lg={3}>
                      <MemberMultiSelectDropdown
                        id="memberSelectInputRef"
                        name="teamMember"
                        labelText="Team Member(s)"
                        fromArray={teamMembersList}
                        formProps={formikprops}
                        isDisabled={
                          formikprops.values.team !== 'all' ||
                          (teamMembersList.length < 1 && true)
                        }
                        innerRef={this.memberSelectInputRef}
                        isAllTeamMemberOption
                        isAllTeamMemberValuesWithNoArray
                        requiredValueAs="userId"
                        showErrorMessage
                      />
                    </Col>
                  )}

                <Col md={6} lg={3}>
                  <Form.Group>
                    <Form.Label>Date range</Form.Label>
                    <DateRangePicker
                      onEvent={this.handleDateSelect}
                      initialSettings={{
                        autoUpdateInput: false,
                        singleDatePicker: false,
                        startDate: moment().toDate(),
                        locale: {
                          format: 'MMM D, YYYY',
                        },
                        alwaysShowCalendars: true,
                        autoApply: true,
                      }}
                    >
                      <input
                        type="text"
                        className="form-control icon-calendar"
                        placeholder={`${moment().format(
                          'MMM D, YYYY'
                        )} - ${moment().format('MMM D, YYYY')}`}
                      />
                    </DateRangePicker>
                  </Form.Group>
                </Col>
                {permissions &&
                  permissions.includes('timezone_dropdown_view') && (
                    <Col md={6} lg={3}>
                      <Form.Group controlId="Timezone">
                        <Form.Label>Timezone</Form.Label>
                        <TimeZoneDropdown
                          timeZoneName="timeZone"
                          formik={formikprops}
                          defaultValue={timeZone}
                        />
                      </Form.Group>
                    </Col>
                  )}
                <Col md={6} lg={3}>
                  <StatusDropdown
                    statusList={[
                      { statusName: 'Early checkout' },
                      { statusName: 'Late checkin' },
                    ]}
                    handleChange={formikprops.handleChange}
                  />
                </Col>
                <Col xs={12}>
                  <Form.Group controlId="excludeArchivedProjects">
                    <Form.Check
                      name="excludeArchivedProjects"
                      type="checkbox"
                      label="Exclude archived projects"
                      checked={formikprops.values.excludeArchivedProjects}
                      className="pt-3"
                      onChange={() =>
                        formikprops.setFieldValue(
                          'excludeArchivedProjects',
                          !formikprops.values.excludeArchivedProjects
                        )
                      }
                    />
                  </Form.Group>
                  <Form.Group controlId="generateData">
                    <div>
                      {numberOfDaysSelected > 7 ? (
                        <Button
                          variant="primary"
                          disabled={numberOfDaysSelected > daysLimit}
                          onClick={() => {
                            this.handleViewingLimitFilter(formikprops.values);
                          }}
                        >
                          Generate
                        </Button>
                      ) : (
                        <Button
                          variant="primary"
                          type="Submit"
                          disabled={numberOfDaysSelected > daysLimit}
                        >
                          Generate
                        </Button>
                      )}
                    </div>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
        {showViewingLimitAlert && numberOfDaysSelected > 7 ? (
          <Card>
            <Card.Header>
              <div className="card-title h4 m-0">{this.pageHeading.title}</div>
            </Card.Header>
            <Card.Body>
              <Alert variant="light" className="mb-0 py-4">
                <p>
                  <strong>
                    Adherence details can be viewed on screen for a maximum of 7
                    days. You can, however, use the option below to export a
                    report for the selected date range.
                  </strong>
                </p>
                <div className="mt-3">
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => this.handleAsyncExport()}
                  >
                    Export Excel
                  </Button>
                </div>
              </Alert>
            </Card.Body>
          </Card>
        ) : (
          <Card style={{ marginBottom: '0px !important' }}>
            <Card.Header>
              <Row className="align-items-center my-3">
                <Col>
                  <div className="card-title h4 m-0">
                    {this.pageHeading.title}
                  </div>
                </Col>

                {data && data.length > 0 && (
                  <Col xs="auto" className="ml-auto">
                    Download as{' '}
                    <Button
                      variant="white"
                      type="button"
                      size="sm"
                      className="mx-1"
                      disabled={numberOfDaysSelected > daysLimit}
                      onClick={() => {
                        this.handleAsyncExport();
                      }}
                    >
                      Excel
                    </Button>
                  </Col>
                )}
              </Row>
            </Card.Header>

            <div className="text-muted">
              {initLoad && (
                <AdherenceDataTable
                  isLoading={isLoading}
                  totalRows={activityMetadata.total}
                  projectsData={data}
                  perPage={activityMetadata.limit}
                  handlePageChange={this.handlePageChange}
                  handleLimitChange={this.handleLimitChange}
                />
              )}
            </div>
          </Card>
        )}
        <br />
        <ReportGenerationModal
          showModal={reportModalDisplay}
          setShowModal={this.handleReportModalDisplay}
          formParams={formParams}
          dateRange={{ startDate, endDate }}
          permissions={permissions}
          handleLoader={this.handleLoader}
          isLoading={isLoading}
          reportType="adherence"
        />
        {/* Loader */}
        {(isLoading ||
          isUpdatingProjectsList ||
          isUpdatingTeamsList ||
          isUpdatingClientsList) && <Loading contentAreaOnly />}
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  const { hierarchy, permissionsReducer } = state;
  return {
    hierarchy,
    permissions: permissionsReducer,
  };
};

MemberLiveActivity.propTypes = {
  hierarchy: PropTypes.object,
  permissions: PropTypes.array,
};

export default connect(mapStateToProps)(MemberLiveActivity);
